<template>
    <div>
        <div class="row pb-3">
            <div class="col-sm-12">
                <h4 class="font-weight-bold">Documentos</h4>
            </div>
        </div>
        <form @submit.prevent="submit">
            <div class="row">
                <form-select
                    grid="6"
                    v-model="documento.registro_cartorio"
                    :itens="$root.arrays.registro_cartorio"
                    label="Usuário registrado em cartório?"
                />
                <form-select
                    grid="6"
                    v-model="documento.tipo_certidao"
                    :itens="$root.arrays.tipo_certidao"
                    label="Tipo de certidão"
                />
                <div class="col-md-12 col-sm-12 row pr-0">
                    <form-input
                        grid="12"
                        v-model="documento.cartorio_nome"
                        label="Nome do Cartório"
                    />
                    <form-input
                        grid="6"
                        v-model="documento.cartorio_livro"
                        label="Livro"
                    />
                    <form-input
                        grid="6"
                        v-model="documento.cartorio_folha"
                        label="Folha"
                    />
                    <form-input
                        grid="6"
                        v-model="documento.termo_rani"
                        label="Termo/Rani"
                    />
                    <form-input
                        grid="6"
                        v-model="documento.termo_matricula"
                        label="Termo/Matrícula"
                    />
                </div>
                <form-input
                    v-model="documento.termo_certidao"
                    label="Termo da certidão ou matrícula das certidões novas"
                />
                <form-calendar
                    grid="4"
                    v-model="documento.certidao_data_emissao"
                    label="Data da emissão da Certidão"
                />
                <form-select
                    grid="4"
                    v-model="documento.certidao_uf"
                    :itens="$root.arrays.estados"
                    label="Estado da certidão"
                    @change="getMunicipios(documento.certidao_uf, true)"
                />
                <form-select
                    grid="4"
                    v-model="documento.certidao_municipio"
                    :itens="municipios"
                    label="Município da certidão"
                    :loading="loadingMunicipios"
                />
                <form-select
                    grid="12"
                    v-model="documento.providenciar_documentacao"
                    :itens="$root.arrays.providenciar_documentacao"
                    label="Necessidade de providenciar documentação civil"
                    multiple
                />
            </div>
            <div class="row">
                <form-input
                    v-model="documento.cpf"
                    grid="6"
                    label="CPF"
                    v-mask="'###.###.###-##'"
                    :required="true"
                    :readonly="documento.nao_sabe_cpf == 1 ? true : false"
                    :minlength="14"
                    :maxlength="14"
                />
                <form-input
                    v-model="documento.nis"
                    grid="6"
                    label="NIS"
                    :required="true"
                    :readonly="documento.nao_sabe_nis == 1 ? true : false"
                />
                <form-toggle
                    v-if="documento.cpf == null || documento.cpf == ''"
                    v-model="documento.nao_sabe_cpf"
                    grid="6"
                    mt="0"
                    label="Não sabe o CPF"
                />
                <span v-else class="col-md-6 col-sm-12"></span>
                <form-toggle
                    v-if="documento.nis == null || documento.nis == ''"
                    v-model="documento.nao_sabe_nis"
                    grid="6"
                    mt="0"
                    label="Não sabe o NIS"
                />
            </div>
            <div class="row">
                <form-input
                    v-model="documento.alistamento_militar"
                    grid="4"
                    v-mask="'##.###.######.#'"
                    label="Alistamento Militar"
                />
                <form-input
                    v-model="documento.passaporte"
                    grid="4"
                    label="Passaporte (Estrangeiro)"
                />
                <form-input
                    v-model="documento.pis_pasep"
                    v-mask="'###.#####.##-#'"
                    grid="4"
                    label="PIS/PASEP"
                />
                <form-input v-model="documento.rg" grid="6" label="Número do RG" />
                <form-input
                    v-model="documento.rg_org_expedidor"
                    grid="6"
                    label="Org. Expedidor RG"
                />
                <form-input v-model="documento.rg_uf" grid="4" label="UF RG" />
                <form-input
                    v-model="documento.rg_complemento"
                    grid="4"
                    label="Complemento RG"
                />
                <form-calendar
                    v-model="documento.rg_emissao"
                    grid="4"
                    label="Data de emissão RG"
                />
                <form-input
                    v-model="documento.ctps"
                    grid="4"
                    label="Nº da Carteira de Trabalho"
                />
                <form-input v-model="documento.ctps_serie" grid="3" label="Série" />
                <form-select
                    v-model="documento.ctps_uf"
                    :itens="$root.arrays.estados"
                    grid="2"
                    label="UF"
                />
                <form-calendar
                    v-model="documento.ctps_emissao"
                    grid="3"
                    label="Data de emissão"
                />
                <form-input
                    v-model="documento.titulo_eleitor"
                    grid="4"
                    label="Nº Título de Eleitor"
                />
                <form-input v-model="documento.titulo_zona" grid="4" label="Zona" />
                <form-input
                    v-model="documento.titulo_secao"
                    grid="4"
                    label="Seção"
                />
                <form-input
                    v-model="documento.cnh"
                    grid="4"
                    label="CNH (Nº Registro)"
                />
                <form-input
                    v-model="documento.num_formulario"
                    grid="4"
                    label="Nº Formulário"
                />
                <form-input v-model="documento.renach" grid="4" label="RENACH" />
            </div>
            <div class="row pt-3 pb-2">
                <div class="col-12">
                    <h5 class="font-weight-bold">Biometria Integrada</h5>
                </div>
            </div>
            <div class="row" v-for="biometria in biometrias" :key="biometria.origem">
                <div class="col-md-6 col-sm-12">
                    <div class="form-group mb-2">
                        <label :for="'biometria-' + biometria.origem" class="d-block font-weight-bold">
                            Indicador se pessoa tem cadastro {{ biometria.preposicao }} {{ biometria.origem }}
                        </label>
                        <v-select
                            :input-id="'biometria-' + biometria.origem"
                            v-model="documento['IN-BIOMETRIA-' + biometria.origem]"
                            :options="opcoesBiometria"
                            label="text"
                            :reduce="opcao => opcao.value"
                            :searchable="false"
                            placeholder="Selecione"
                        >
                            <template #no-options>
                                <em style="opacity: 0.5">Nenhum resultado encontrado.</em>
                            </template>
                        </v-select>
                    </div>
                </div>
                <form-calendar
                    grid="6"
                    v-model="documento['DT-INTGO-BIOMETRIA-' + biometria.origem]"
                    :label="'Data da integração do cadastro ' + biometria.preposicao + ' ' + biometria.origem"
                    :masks="{ input: 'DD/MM/YYYY' }"
                />
            </div>
            <div class="row pt-4 px-2 d-flex justify-content-end">
                <button type="submit" class="btn btn-success btn-submit">
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            documento: {},
            biometrias: [
                { origem: "CIN", preposicao: "no" },
                { origem: "CNH", preposicao: "na" },
                { origem: "TSE", preposicao: "no" },
            ],
            opcoesBiometria: [
                { value: 0, text: "Não" },
                { value: 1, text: "Sim" },
            ],
            municipios: [],
            nao_sabe_cpf: 0,
            nao_sabe_nis: 0,
            loadingMunicipios: false,
        };
    },
    mounted() {
        this.setValue();
    },
    watch: {
        item(n, o) {
            this.setValue();
        },
        documento(n, o) {
            this.setValue();
        },
    },
    methods: {
        setValue() {
            if (this.item.documento != null) {
                // if (this.item.documento.nis == 0) {
                // 	this.nao_sabe_nis = 1;
                // 	this.item.documento.nis = null;
                // } else if (this.item.documento.nis == "") {
                // 	this.nao_sabe_nis = 0;
                // 	this.item.documento.nis = null;
                // }

                // if (this.item.documento.cpf == 0) {
                // 	this.nao_sabe_cpf = 1;
                // 	this.item.documento.cpf = null;
                // } else if (this.item.documento.cpf == "") {
                // 	this.nao_sabe_cpf = 0;
                // 	this.item.documento.cpf = null;
                // }
                this.getMunicipios(
                    this.item.documento.certidao_uf,
                    false,
                    true
                );
                this.documento = this.item.documento;
            } else {
                this.getMunicipios();
            }
        },
        getMunicipios(uf = null, load = false, init = false) {
            this.loadingMunicipios = load;
            let id = null;
            if (uf == null) {
                id = this.$store.state.settings.app_estado_id;
            }

            if (id) {
                axios
                    .get(
                        `get-cidades/${this.$store.state.settings.app_estado_id}`
                    )
                    .then((respose) => {
                        this.municipios = respose.data;
                    })
                    .finally(() => {
                        this.loadingMunicipios = false;
                    });
            } else {
                if (init == false) {
                    this.documento.certidao_municipio = null;
                }
                axios
                    .get(`get-cidades-uf/${uf}`)
                    .then((respose) => {
                        this.municipios = respose.data;
                    })
                    .finally(() => {
                        this.loadingMunicipios = false;
                    });
            }
        },
        submit() {
            if (this.nao_sabe_nis == 1) {
                this.documento.nis = 0;
            }
            if (this.nao_sabe_cpf == 1) {
                this.documento.cpf = 0;
            }
            this.item.documento = this.documento;

            this.$emit("submit");
        },
    },
};
</script>
